import script from "./ClientContactFormVertical.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientContactFormVertical.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__